/*
 * Http service class which will be used to make requests
 */
const _gReqHeaders = {
  pragma: 'no-cache',
  'cache-control': 'no-cache',
};

class HttpService {
  constructor() {
    this._cGET = 'GET';
    this._cPOST = 'POST';
    this._cHEAD = 'HEAD';
    this.headers = { client_secret: '', uid: '', 'Accept': 'application/json', 'Content-Type': 'application/json' };
  }

  getURLQueryParams(_pUrl, _pReqObj) {
    let _vQueryParam = '';
    if (!_pReqObj) _pReqObj = {};
    for (const _vKey in _pReqObj) {
      if (_pReqObj.hasOwnProperty(_vKey)) {
        _vQueryParam += '&' + _vKey + '=' + _pReqObj[_vKey];
      }
    }
    if (_vQueryParam) _vQueryParam = _vQueryParam.replace('&', '?')
    return {
      url: _pUrl + _vQueryParam,
      queryParams: _vQueryParam,
    };
  }

  http(_pHost, _pEndpoint, _pMethod, _pPostData, _pHeaders, _pScb, _pEcb) {
    _pHost = ['https://eecc-alb-external-57445687.eu-central-1.elb.amazonaws.com'.toLowerCase()]
      .indexOf(window.location.origin.toLowerCase()) > -1 ? 'https://eecc-alb-external-57445687.eu-central-1.elb.amazonaws.com' : 
      ['https://eecc-alb-external-1303450943.eu-central-1.elb.amazonaws.com'.toLowerCase()]
      .indexOf(window.location.origin.toLowerCase()) > -1 ? 'https://eecc-alb-external-1303450943.eu-central-1.elb.amazonaws.com' :      
      _pHost;
    if (_pHeaders === '') _pHeaders = _gReqHeaders;
    const _vRequest = {
      method: _pMethod ? _pMethod : this._cGET,
      headers: _pHeaders,
    };
    if (_pPostData) _vRequest.body = _pPostData
    fetch(_pHost + _pEndpoint, _vRequest).then(
      _cbpResponse => {
        try {
          return _cbpResponse
            .json()
            .then(_cbpResponseJson => {
              _pScb(_cbpResponse.status, _cbpResponseJson);
            })
            .catch(_cbpError => {
              _pEcb(_cbpError);
            });
        } catch (_pError) {
          _pScb(_cbpResponse.status, _cbpResponse);
        }
      },
      _cbpError => {
        _pEcb(_cbpError);
      },
    );
  }

  async callMiddleware(host, endpoint, client_secret, uid, requestMethod = 'GET', requestBody = '') {
    host = ['https://eecc-alb-external-57445687.eu-central-1.elb.amazonaws.com'.toLowerCase()]
      .indexOf(window.location.origin.toLowerCase()) > -1 ? 'https://eecc-alb-external-57445687.eu-central-1.elb.amazonaws.com' : 
      ['https://eecc-alb-external-1303450943.eu-central-1.elb.amazonaws.com'.toLowerCase()]
      .indexOf(window.location.origin.toLowerCase()) > -1 ? 'https://eecc-alb-external-1303450943.eu-central-1.elb.amazonaws.com' :
      host;
    this.headers.uid = uid;
    this.headers.client_secret = client_secret;
    let requestOptions = { method: requestMethod, headers: this.headers };
    if (['POST', 'PATCH'].indexOf(requestMethod.toUpperCase()) > -1) {
      requestOptions.body = requestBody;
    }
    return fetch(host + endpoint, requestOptions)
      .catch(e => { throw e })
      .then(r => {
        if (r.status !== 200) {
          throw r;
        }
        return r;
      })
      .then(response => response.json());
  }

}

export { HttpService };
